"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_MAPPER = void 0;
var ICON_MAPPER = {
  1: 'WifiIcon',
  2: 'PoolIcon',
  3: 'FitnessCenterIcon',
  4: 'SpaIcon',
  5: 'WavesIcon',
  6: 'AirportShuttleIcon',
  7: 'SmokingRoomsIcon',
  8: 'SmokeFreeIcon',
  9: 'RestaurantIcon',
  10: 'PoolsideBar',
  11: 'LocalCafeIcon',
  12: 'LocalBarIcon',
  13: 'SportsTennisIcon',
  14: 'HotTubIcon',
  15: 'NightclubIcon',
  16: 'LocalParkingIcon',
  17: 'RoomServiceIcon',
  18: 'LocalLaundryServiceIcon',
  19: 'LuggageStorageIcon',
  20: 'BusinessCenterIcon',
  21: 'GardenIcon',
  22: 'ConciergeServicesIcon'
};
exports.ICON_MAPPER = ICON_MAPPER;